import { useState } from "react";
import { useTranslation } from "react-i18next";
import modalState from "../../../state-observables/modal/ModalState";
import styles from "./styles.module.css";
import SimpleButton from "../../disposables/buttons/SimpleButton";


type Props = {
  otherInfoObject?: object;
};


export default function DetailedFeedbackModal({ otherInfoObject }: Props) {
  const { t } = useTranslation();
  const [report, setReport] = useState("");
  const [email, setEmail] = useState("");
  const [reportSent, setReportSent] = useState(false);

  const onReport = () => {
    if (!report) return;
    if (!email) {
      const confirm = window.confirm(
        t("detailed_feedback_modal.no_email_confirm") || ""
      );
      if (!confirm) return;
    }
    const reportWithContact = { text: `${email ? email : t('detailed_feedback_modal.anonymous', 'Anonymous')}: ${report}` };
    // window.applicationManager.analyticsManager.logEvent("textfeedback", { ...reportWithContact, ...otherInfoObject });
    setReportSent(true)
    modalState.updateModalProps({ modalTitle: "🚀" });
    setTimeout(() => modalState.closeModal(), 1500);
  };

  return (
    <div className={styles.bugReportModalContainer}>
      {reportSent ? (
        t("detailed_feedback_modal.thank_you", "Thank you for your feedback!")
      ) : (
        <>
          <div className={styles.bugReportModalInfo}>
            {t("detailed_feedback_modal.info", "Please help us improve! Please let us know if you spot any irregularities/bugs. ")}<strong className={styles.bugReportModalInfoStrong}>{t("detailed_feedback_modal.info_strong", "You can optionally leave your contact details so we can reach out and help you")}</strong>. {t("detailed_feedback_modal.thank_you", "Thank you!")}
          </div>
          <div className={styles.bugReportModalForm}>
            <textarea
              className={styles.bugReportModalTextInput}
              placeholder={t("detailed_feedback_modal.report_placeholder", "Your report...") || "Your report..."}
              onChange={(e) => setReport(e.target.value)}
              value={report}
            />
            <label className={styles.bugReportModalEmailLabel}>
              {t("detailed_feedback_modal.email_label", "Provide your email if you want us to get back to you with a solution!")}
            </label>
            <input
              type="email"
              className={styles.bugReportModalEmailInput}
              placeholder={t("detailed_feedback_modal.email_placeholder", "Email (optional)") || "Email (optional)"}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>
          <div className={styles.bugReportModalButtons}>
            <SimpleButton
              onClick={() => modalState.closeModal()}
              title={t("detailed_feedback_modal.cancel", "Cancel")}
            />
            <SimpleButton onClick={onReport} title={t("detailed_feedback_modal.report", "Report")} />
          </div>
        </>
      )}
    </div>
  );
}
